
export default [

    // {
    //     visible: () => true,
    //     open:true,
    //     title: "Temporary Phone Line Fault",
    //     content: "<p>We have a temporary fault with our phone lines, and are unable to answer incoming calls.</p>" +
    //         "<p>Until this is resolved, if you need to contact the office, could you please send an Instant Message via the member’s area or send on email to <a href='enquiries@cashbox.org.uk' target='_blank'>enquiries@cashbox.org.uk</a></p>"
    // },
    // {
    //     title: "Bank Holiday Weekend",
    //     image: "spring.png",
    //     content: "<img alt='Spring Bank Holiday' src=\"/alerts/spring.png\" " +
    //         "class=\"p-0 m-0 pb-3 float-none rounded float-sm-right col col-sm-6 pl-sm-3 col-md-4 pb-md-0 \" />" +
    //         "<p>Our offices will be closed on Monday 26th May 2025 for the Bank Holiday Weekend.</p>" +
    //         "<p>We will reopen at 9am on Tuesday 27th May 2025.</p>" +
    //         "<p>Child Benefit Payments due into accounts on Monday 26th May 2025 will be processed on Friday 23rd May 2025, on receipt from HMRC.</p>" +
    //         "<p>We would like to wish all our members a happy Bank Holiday Weekend!</p>",
    //     visible: () => {
    //         const today = new Date();
    //         const springBankHoliday = new Date(today.getFullYear(), 4, 26);
    //         const beforeBankHoliday = new Date(springBankHoliday);
    //         beforeBankHoliday.setDate(beforeBankHoliday.getDate() - 14);
    //         const afterBankHoliday = new Date(springBankHoliday);
    //         afterBankHoliday.setDate(afterBankHoliday.getDate() + 3);
    //         return today > beforeBankHoliday && today < afterBankHoliday;
    //     },
    //     open: true
    // },
    // {
    //     title: "May Bank Holiday",
    //     image: "may.png",
    //     content: "<img alt='easter' src=\"/alerts/may.png\" " +
    //         "class=\"p-0 m-0 pb-3 float-none rounded float-sm-right col col-sm-6 pl-sm-3 col-md-4 pb-md-0 \" />" +
    //         "<p>Our offices will be closed on Monday 1st May 2023.</p>" +
    //         "<p>We will reopen at 9am on Tuesday 2nd May 2023.</p>" +
    //         "<p>Child Benefit Payments due into accounts on Monday 1st May 2023 will be processed on Friday 28th April 2023, on receipt from HMRC.</p>" +
    //         "<p>Loan applications submitted after Tuesday 25th April 2023 will be reviewed on Wednesday 3rd May 2023.</p>" +
    //         "<p>Enjoy the Bank Holiday Weekend!</p>",
    //     visible: () => {
    //         const today = new Date();
    //         const mayDay = new Date(today.getFullYear(), 3, 1);
    //         const beforeMayDay = new Date(mayDay);
    //         beforeMayDay.setDate(beforeMayDay.getDate() - 4);
    //         const afterMayDay = new Date(mayDay);
    //         afterMayDay.setDate(afterMayDay.getDate() + 3);
    //         return today > beforeMayDay && today < afterMayDay;
    //     },
    //     open: true
    // },
    // {
    //     title: "Easter Opening Hours",
    //     image: "easter.png",
    //     content: "<img alt='easter' src=\"/alerts/easter.png\" " +
    //         "class=\"p-0 m-0 pb-3 float-none rounded float-sm-right col col-sm-6 pl-sm-3 col-md-4 pb-md-0 \" />" +
    //         "<p>Our offices will be closed from 4:30pm on Thursday 2nd April 2026.</p>" +
    //         "<p>We reopen at 9am on Tuesday 7th April 2026.</p>" +
    //         "<p>Child Benefit Payments due into accounts on Monday 6th April 2026 will be processed on Thursday 2nd April 2026.</p>" +
    //         "<p>We would like to wish all our members a Happy Easter!</p>",
    //     visible: () => {
    //         const today = new Date();
    //         const easterMonday = new Date(today.getFullYear(), 3, 6);
    //         const beforeEasterMonday = new Date(easterMonday);
    //         beforeEasterMonday.setDate(beforeEasterMonday.getDate() - 14);
    //         const easterMondayPlusOne = new Date(easterMonday);
    //         easterMondayPlusOne.setDate(easterMondayPlusOne.getDate() + 1);
    //         return today > beforeEasterMonday && today < easterMondayPlusOne;
    //     },
    //     open: true
    // },
    // {
    //     title: "August Bank Holiday",
    //     image: "easter.png",
    //     content: "<img alt='august bank holiday' src=\"/alerts/august.png\" " +
    //         "class=\"p-0 m-0 pb-3 float-none rounded float-sm-right col col-sm-6 pl-sm-3 col-md-4 pb-md-0 \" />" +
    //         "<p>Our offices will be closed on Monday 26th August 2024 for the Bank Holiday.</p>" +
    //         "<p>Loan applications submitted after Tuesday 20th August 2024 will be assessed on Wednesday 27th August 2024.</p>" +
    //         "<p>We would like to wish all our members a Happy Bank Holiday Weekend!</p>",
    //     visible: () => {
    //         const today = new Date();
    //         const augustBankHolidayMondayPlusOne = new Date(today.getFullYear(), 7, 27);
    //         const beforeAugustBankHoliday = new Date(augustBankHolidayMondayPlusOne);
    //         beforeAugustBankHoliday.setDate(beforeAugustBankHoliday.getDate() - 5);
    //         return today > beforeAugustBankHoliday && today < augustBankHolidayMondayPlusOne;
    //     },
    //     open: true
    // },
    // {
    //     title: "Child Benefit Payments Monday 2nd October 2023",
    //     content: "<p>" +
    //         "There may be a delay with payments due to be paid out to member’s bank accounts today." +
    //         "<p>" +
    //         "We will transfer the funds over as soon as possible." +
    //         "</p>",
    //     visible: () => {
    //         const today = new Date();
    //         const octoberFifth = new Date(today.getFullYear(), 9, 5);
    //         return today < octoberFifth;
    //     },
    //     open: true
    // },
    // {
    //     title: "AGM 2023 Attendance...",
    //     content: "<p>" +
    //         "Everyone at the Credit Union would like to thank all our members who attended the AGM earlier this month!</p><p>Due to the good attendance, we have donated £50 to ‘The bread and butter thing’ as promised in our AGM invitation." +
    //         "</p>",
    //     open: true
    // },
    // {
    //     title: "Christmas Saver Update 2025",
    //     open: true,
    //     content:
    //         "<img alt='Christmas Opening Times' src=\"/alerts/xmas.png\" " +
    //         "class=\"p-0 m-0 pb-3 float-none rounded float-sm-right col col-sm-6 pl-sm-3 col-md-4 pb-md-0 \" />" +
    //         "<p>Thank you to all our members who have been part of our Christmas Savings scheme.</p>" +
    //         "<p>We will be paying all Christmas Savings from 3rd November 2025, if you have not received your savings by 7th November 2025 please <a href='/contact-us'>contact us</a>.</p>" +
    //         "<p>If you would like to continue to save for 2026 then you do not need to do anything your payments will automatically continue.</p>" +
    //         "<p>If you would like to start saving for Christmas, then please <a href='/contact-us'>contact us</a> so we can arrange for this to be set up.</p>" +
    //         "<p><a href='/christmas-savings'>Click here</a> to find out more.</p>"
    // },
    // {
    //     title: "Loan Applications...",
    //     content: "<p>" +
    //         "When you submit a loan application via the members area, you will " +
    //         "receive a notification from us confirming it has been received. If any " +
    //         "further information is required from you we will let you know." +
    //         "</p>" +
    //         "<p>" +
    //         "The average time for a loan decision is 7-10 working days from the " +
    //         "date of application. Please do not contact us for a decision prior to " +
    //         "this unless your circumstances have changed since you submitted your " +
    //         "application." +
    //         "</p>"
    // },
    // {
    //     title: "Helping our members...",
    //     content: "<p>" +
    //         "During the pandemic we improved our online access for members to make " +
    //         "it easier for you to access your savings, apply for products and fully " +
    //         "utilise your membership with Cash Box." +
    //         "</p>" +
    //         "<p>" +
    //         "Visit your " +
    //         "<a href=\"https://cashbox.cuaccount.com/login/\" target=\"_blank\"\n" +
    //         ">new members area</a\n" +
    //         "> " +
    //         "where you can see your account balance, request a share withdrawal and " +
    //         "apply for a loan, Christmas Saver or a Junior Saver for your children." +
    //         "</p>" +
    //         "<p>" +
    //         "Our collection points at Ashton, Denton and Hyde remain closed but you " +
    //         "can continue to make regular payments to your accounts by standing " +
    //         "order or one-off payments via bill payment. Our staff will be happy to " +
    //         "assist you with this." +
    //         "</p>" +
    //         "<p>" +
    //         "Our staff continue to work remotely Monday to Thursday, and are available " +
    //         "by email and phone for member enquiries." +
    //         "</p>" +
    //         "<p>" +
    //         "On Fridays, we will be working from our Denton office where you can " +
    //         "pop in to see us if you need to between 10am and 1pm." +
    //         "</p>" +
    //         "<p>If you need to contact us, please get in touch:</p>" +
    //         "<p>" +
    //         "Email: <a href=\"mailto:enquiries@cashbox.org.uk\">enquiries@cashbox.org.uk</a>" +
    //         "</p>" +
    //         "<p>" +
    //         "Instant Message (IM) by logging into your " +
    //         "<a href=\"https://cashbox.cuaccount.com/login/\" target=\"_blank\">Members Area</a>." +
    //         "</p>" +
    //         "<p>" +
    //         "Telephone: <a href=\"tel:01613423266\">0161 342 3266</a>" +
    //         "<br />" +
    //         "Available from 11am to 1pm Monday, Tuesday, Thursday and Friday" +
    //         "</p>"
    // },
    // {
    //     title: "Denton Office Closed - Friday 13th December 2024",
    //     content: "<p>Our Denton Office will be closed on Friday 13th December for staff training.</p>" +
    //         "<p>You can still contact us by phone or email, and you will still be able to log onto the members area and carry out transactions online.</p>" +
    //         "<p>We apologise for any inconvenience this may cause and thank you for your understanding.</p>",
    //     visible: () => {
    //         const today = new Date();
    //         const dentonClosed = new Date(today.getFullYear(), 11, 13);
    //         return today <= dentonClosed;
    //     },
    //     open: true
    // },
    // {
    //     title: "Christmas Opening Times",
    //     image: "xmas.png",
    //     content: "<img alt='Christmas Opening Times' src=\"/alerts/xmas.png\" " +
    //              "class=\"p-0 m-0 pb-3 float-none rounded float-sm-right col col-sm-6 pl-sm-3 col-md-4 pb-md-0 \" />" +
    //         "<p>Our offices will be closed from 1pm on Wednesday 24th December 2025 and reopen at 9am on Friday 2nd January 2026.</p>" +
    //         "<p>The latest date for loan applications requiring a decision before Christmas is Wednesday, 17th December 2025 and you will need to ensure that any evidence we require to support your loan application is provided before 5pm.</p>" +
    //         "<p>We would like to wish all our members a Very Merry Christmas and Happy New Year!</p>",
    //     visible: () => {
    //         const today = new Date();
    //         const start = new Date(today.getFullYear(), 11, 1);
    //         const end = new Date(today.getFullYear() + (today.getMonth() === 11 ? 1 : -1), 0, 5);
    //         return (today >= start && today <= end);
    //     },
    //     open: true
    // },
    // {
    //     title: "Andy Burnham Celebrates GM Credit Unions & Bee Network Tickets",
    //     content: "" +
    //         "<div class=\"row\">\n" +
    //         "  <div class=\"col-sm-12 col-md-6\">\n" +
    //         "    <p>Andy Burnham, Mayor of GM, yesterday celebrated the sustained growth of GM credit unions and the successful delivery of the Annual Bee Network Tickets with the chiefs of The SoundPound Group credit unions.</p>" +
    //         "    <blockquote>" +
    //         "      <p>&quot;This is exactly what the Bee Network is all about, making travel across Greater Manchester simpler, fairer, and more affordable for everyone. Our partnership with The SoundPound Group is helping thousands of people access the savings and flexibility they need to get around our city-region. It’s a great example of local organisations coming together to deliver real benefits to our communities.</p>" +
    //         "      <p>By giving more people the chance to spread the cost of annual travel and unlock bigger savings, we’re making it easier to leave the car at home and choose public transport with confidence. I’m proud to see our credit unions at the heart of that effort and encourage residents across Greater Manchester to have a look at what your local credit union can offer.&quot;</p>" +
    //         "      <footer class=\"blockquote-footer\">Andy Burnham, Mayor of Greater Manchester.</footer>" +
    //         "    </blockquote>" +
    //         "  </div>" +
    //         "  <div class=\"col-sm-12 col-md-6\">\n" +
    //         "    <img src=\"/alerts/andy_burnham_and_spg_chiefs.jpg\" alt=\"Andy Burnham and SPG Cheifs\" class=\"img img-fluid img-thumbnail\"' >" +
    //         "    <p class=\"text-muted small p-2\">From L to R: Andy Burnham, Mayor of Greater Manchester; Chris Canham – Hoot Credit CU; Ciara Davies – Metro Moneywise CU; Michelle Clegg – Cash Box CU; Lisa Ridgway – No 1 CopperPot CU; Rashida Hossain – YourB CU; Mike Lowden – Oldham CU; Mandy Wilcox – Manchester CU; John Haslam - Stockport CU; Matt Bland – The Money Co-op; Sheenagh Young – South Manchester CU; Mark Brazendale – Salford CU</p>\n" +
    //         "  </div>\n" +
    //         "</div>",
    //     open: false
    // }
]